/**
 * LOV2B PDP 4.8.9 interactions.
 * Scoped to each PDP section and safe for the Shopify theme editor.
 */
(function () {
  'use strict';

  function focusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
  }

  function initPdp(root) {
    if (!root || root.dataset.lov2bInitialized === 'true') return;
    root.dataset.lov2bInitialized = 'true';

    var gallery = root.querySelector('[data-lov2b-gallery]');
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-lov2b-gallery-slide]')) : [];
    var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-lov2b-gallery-thumb]')) : [];
    var dots = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-lov2b-gallery-dot]')) : [];
    var stage = gallery ? gallery.querySelector('[data-lov2b-gallery-stage]') : null;

    function preloadImageElement(img) {
      if (!img || img.dataset.lov2bPreloaded === 'true') return;
      var src = img.currentSrc || img.src;
      if (!src) return;
      var preloader = new Image();
      if (img.sizes) preloader.sizes = img.sizes;
      if (img.srcset) preloader.srcset = img.srcset;
      preloader.src = src;
      img.dataset.lov2bPreloaded = 'true';
    }

    function preloadSlideMedia(mediaId) {
      if (!mediaId) return;
      var target = slides.filter(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      })[0];
      if (!target) return;
      preloadImageElement(target.querySelector('img'));
    }

    function scheduleGalleryPreload() {
      if (!slides.length) return;
      var queue = slides.filter(function (slide) {
        return !slide.classList.contains('is-active');
      }).slice(0, 3).map(function (slide) { return slide.querySelector('img'); }).filter(Boolean);
      var index = 0;
      function run() {
        if (index >= queue.length) return;
        preloadImageElement(queue[index]);
        index += 1;
        window.setTimeout(run, 180);
      }
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1200 });
      } else {
        window.setTimeout(run, 650);
      }
    }

    function setMedia(mediaId, shouldScroll) {
      if (!mediaId) return;
      var normalizedId = String(mediaId);
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', String(slide.dataset.mediaId) === normalizedId);
      });
      thumbs.forEach(function (thumb) {
        var active = String(thumb.dataset.mediaId) === normalizedId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', String(dot.dataset.mediaId) === normalizedId);
      });
      if (shouldScroll && stage && window.matchMedia('(max-width: 989px)').matches) {
        var activeSlide = slides.filter(function (slide) {
          return String(slide.dataset.mediaId) === normalizedId;
        })[0];
        if (activeSlide) activeSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('pointerenter', function () {
        preloadSlideMedia(thumb.dataset.mediaId);
      });
      thumb.addEventListener('focus', function () {
        preloadSlideMedia(thumb.dataset.mediaId);
      });
      thumb.addEventListener('click', function () {
        preloadSlideMedia(thumb.dataset.mediaId);
        setMedia(thumb.dataset.mediaId, true);
      });
    });
    scheduleGalleryPreload();

    if (stage && slides.length > 1) {
      var ticking = false;
      stage.addEventListener('scroll', function () {
        if (!window.matchMedia('(max-width: 989px)').matches || ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var stageLeft = stage.getBoundingClientRect().left;
          var nearest = slides[0];
          var distance = Infinity;
          slides.forEach(function (slide) {
            var current = Math.abs(slide.getBoundingClientRect().left - stageLeft);
            if (current < distance) {
              distance = current;
              nearest = slide;
            }
          });
          if (nearest && nearest.dataset.mediaId) setMedia(nearest.dataset.mediaId, false);
          ticking = false;
        });
      }, { passive: true });
    }

    var qtyInput = root.querySelector('.lov2b-pdp__quantity input[name="quantity"]');
    Array.prototype.slice.call(root.querySelectorAll('[data-lov2b-qty]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var value = Number(qtyInput.value || 1);
        var delta = Number(button.dataset.lov2bQty || 0);
        qtyInput.value = Math.max(1, value + delta);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var variantSelect = root.querySelector('[data-lov2b-variant-select]');
    var price = root.querySelector('[data-lov2b-price]');
    var comparePrice = root.querySelector('[data-lov2b-compare-price]');
    var saleBadge = root.querySelector('[data-lov2b-sale-badge]');
    var savingText = root.querySelector('[data-lov2b-saving-text]');
    var priceBox = root.querySelector('.lov2b-pdp__price');
    var addButton = root.querySelector('[data-lov2b-add-button]');
    var addLabel = root.querySelector('[data-lov2b-add-label]');
    function updateVariant() {
      if (!variantSelect) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      var onSale = option.dataset.onSale === 'true';
      if (comparePrice) {
        comparePrice.textContent = onSale ? (option.dataset.comparePrice || '') : '';
        comparePrice.hidden = !onSale;
      }
      if (saleBadge) {
        saleBadge.textContent = onSale ? ('−' + (option.dataset.salePercent || '') + '% DTO') : '';
        saleBadge.hidden = !onSale;
      }
      if (savingText) {
        savingText.textContent = onSale ? ('Estás ahorrando ' + (option.dataset.savingMoney || '')) : '';
        savingText.hidden = !onSale;
      }
      if (priceBox) priceBox.classList.toggle('is-sale', onSale);
      var available = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      if (option.dataset.mediaId) setMedia(option.dataset.mediaId, false);
    }
    if (variantSelect) variantSelect.addEventListener('change', updateVariant);

    // Mobile active-carousel cue: the button sits above the track and advances one card.
    var activesTrack = root.querySelector('[data-lov2b-actives-track]');
    var activesNav = root.querySelector('[data-lov2b-actives-nav]');
    var activesNext = root.querySelector('[data-lov2b-actives-next]');
    function updateActivesNavigation() {
      if (!activesTrack || !activesNav || !activesNext) return;
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      var canScroll = activesTrack.scrollWidth - activesTrack.clientWidth > 8;
      var atEnd = activesTrack.scrollLeft + activesTrack.clientWidth >= activesTrack.scrollWidth - 8;
      activesNav.classList.toggle('is-hidden', !mobile || !canScroll || atEnd);
      activesNext.tabIndex = (!mobile || !canScroll || atEnd) ? -1 : 0;
    }
    if (activesTrack && activesNext) {
      activesNext.addEventListener('click', function () {
        var card = activesTrack.querySelector('.lov2b-pdp__active-card:not([data-lov2b-active-extra]), .lov2b-pdp__active-card');
        var amount = card ? card.getBoundingClientRect().width + 12 : activesTrack.clientWidth * .76;
        activesTrack.scrollBy({ left: amount, behavior: 'smooth' });
      });
      activesTrack.addEventListener('scroll', updateActivesNavigation, { passive: true });
      window.addEventListener('resize', updateActivesNavigation);
      window.setTimeout(updateActivesNavigation, 0);
    }

    // Activos: se muestran seis al inicio y el botón revela u oculta el resto.
    var activeExtras = activesTrack ? Array.prototype.slice.call(activesTrack.querySelectorAll('[data-lov2b-active-extra]')) : [];
    var activesToggle = root.querySelector('[data-lov2b-actives-toggle]');
    function setActivesExpanded(expanded) {
      if (!activeExtras.length || !activesToggle) return;
      root.classList.toggle('is-actives-collapsed', !expanded);
      activesToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      activesToggle.textContent = expanded
        ? (activesToggle.dataset.labelLess || 'Ver menos')
        : (activesToggle.dataset.labelMore || 'Ver más');
      window.setTimeout(updateActivesNavigation, 0);
    }
    if (activeExtras.length && activesToggle) {
      setActivesExpanded(false);
      activesToggle.addEventListener('click', function () {
        setActivesExpanded(root.classList.contains('is-actives-collapsed'));
      });
    }

    var modal = root.querySelector('[data-lov2b-modal]');
    var modalBody = root.querySelector('[data-lov2b-modal-body]');
    var backdrop = root.querySelector('.lov2b-pdp__modal-backdrop');
    var closeButton = root.querySelector('.lov2b-pdp__modal-close');
    var previousFocus = null;

    function closeModal() {
      if (!modal || !root.classList.contains('is-modal-open')) return;
      root.classList.remove('is-modal-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lov2b-modal-lock');
      document.body.classList.remove('lov2b-modal-lock');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      previousFocus = null;
    }

    function openModal(templateId, trigger) {
      if (!modal || !modalBody || !templateId) return;
      var template = document.getElementById(templateId);
      if (!template || !root.contains(template)) return;
      previousFocus = trigger || document.activeElement;
      modalBody.innerHTML = template.innerHTML;
      var heading = modalBody.querySelector('h3');
      if (heading) heading.id = modal.id + '-title';
      modal.setAttribute('aria-hidden', 'false');
      root.classList.add('is-modal-open');
      document.documentElement.classList.add('lov2b-modal-lock');
      document.body.classList.add('lov2b-modal-lock');
      window.setTimeout(function () {
        var first = focusableElements(modal)[0] || modal.querySelector('[data-lov2b-modal-close]');
        if (first) first.focus();
      }, 0);
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-lov2b-modal-target]')).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger.dataset.lov2bModalTarget, trigger);
      });
    });

    // Any pointer press outside the dialog closes it. The following click is
    // suppressed too, so an active card behind the backdrop cannot reopen a modal.
    var suppressOutsideClick = false;
    var suppressOutsideClickTimer = null;

    function stopEvent(event) {
      if (!event) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }

    function armClickSuppression() {
      suppressOutsideClick = true;
      window.clearTimeout(suppressOutsideClickTimer);
      suppressOutsideClickTimer = window.setTimeout(function () {
        suppressOutsideClick = false;
      }, 450);
    }

    function closeWhenPointerLeavesModal(event) {
      if (!modal || !root.classList.contains('is-modal-open')) return;
      if (modal.contains(event.target)) return;
      armClickSuppression();
      stopEvent(event);
      closeModal();
    }

    function suppressClickAfterOutsideClose(event) {
      if (!suppressOutsideClick) return;
      if (modal && modal.contains(event.target)) return;
      suppressOutsideClick = false;
      stopEvent(event);
    }

    if (backdrop) {
      backdrop.addEventListener('pointerdown', closeWhenPointerLeavesModal, true);
    }
    document.addEventListener('pointerdown', closeWhenPointerLeavesModal, true);
    document.addEventListener('click', suppressClickAfterOutsideClose, true);
    if (closeButton) closeButton.addEventListener('click', closeModal);

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key !== 'Tab' || !root.classList.contains('is-modal-open') || !modal) return;
      var focusables = focusableElements(modal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function boot(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-lov2b-pdp]')) initPdp(container);
    if (container.querySelectorAll) {
      Array.prototype.slice.call(container.querySelectorAll('[data-lov2b-pdp]')).forEach(initPdp);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
